import { useEffect, useRef, useState } from "react";
import { Sparkles, Volume2, VolumeX } from "lucide-react";

import { pickText } from "@/lib/content";
import { KONSHUS_NAME, KONSHUS_POSTER_URL, KONSHUS_VIDEO_URL } from "@/lib/vip";

export const KonshusChamberStage = ({ language }) => {
  const [ambientOn, setAmbientOn] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    if (ambientOn) {
      audio.volume = 0.25;
      audio.play().catch(() => setAmbientOn(false));
    } else {
      audio.pause();
    }
  }, [ambientOn]);

  return (
    <div className="relative mb-5 overflow-hidden rounded-[1.5rem] border border-white/10" data-testid="konshus-chamber-stage">
      <video autoPlay className="h-48 w-full object-cover opacity-55" loop muted playsInline poster={KONSHUS_POSTER_URL}>
        <source src={KONSHUS_VIDEO_URL} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(212,175,55,0.18),transparent_35%)]" />
      <div className="absolute inset-6 rounded-full border border-primary/15" />
      <div className="absolute inset-12 rounded-full border border-white/10" />
      <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between gap-4">
        <div>
          <p className="section-label">{pickText(language, "Theatrical Chamber", "Camera Teatrale")}</p>
          <h3 className="mt-2 text-3xl text-foreground">{KONSHUS_NAME}</h3>
          <p className="mt-2 max-w-xl text-sm text-slate-300">
            {pickText(language, "A cinematic ritual presence with symbolic overlays, moving light, and ambient chamber media.", "Una presenza rituale cinematografica con sovrapposizioni simboliche, luce in movimento e media ambientali della camera.")}
          </p>
        </div>
        <button
          className="ghost-button rounded-full bg-black/35 px-4 py-2"
          data-testid="konshus-ambient-toggle-button"
          onClick={() => setAmbientOn((current) => !current)}
          type="button"
        >
          {ambientOn ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
          {ambientOn ? pickText(language, "Mute ambience", "Silenzia ambiente") : pickText(language, "Play ambience", "Riproduci ambiente")}
        </button>
      </div>
      <div className="absolute right-6 top-6 flex items-center gap-2 rounded-full border border-white/10 bg-black/30 px-3 py-2 text-xs uppercase tracking-[0.24em] text-primary">
        <Sparkles className="h-4 w-4" />
        {pickText(language, "Ritual overlays active", "Sovrapposizioni rituali attive")}
      </div>
      <audio loop ref={audioRef} src="/konshus-ambient.mp3" />
    </div>
  );
};